
export default {
  name: 'BaseTable',
  props: {
    /**
     * Object items to display
     */
    header: {
      type: Array,
      default: () => [],
    },

    rows: {
      type: Array,
      required: true,
    },
  },

  computed: {
    columnsOrder () {
      if (this.header.length) {
        return this.header
      } else {
        return Object.entries(this.rows[0]).reduce((acc, [key]) => {
          acc.push({
            name: '',
            key,
          })

          return acc
        }, [])
      }
    },
  },
}
